<template>
    <b-row>
        <b-col>
            <b-row class="je-headers">
                <b-col><i class="ni ni-fat-delete"></i></b-col>
                <b-col><h5>Key</h5></b-col>
                <b-col><h5>Value</h5></b-col>
                <b-col><h5>Type</h5></b-col>
            </b-row>
            <div v-for="(data,index) in dataAsArray" v-bind:key="index" class="je-input-row">
                    <base-button icon type="danger" class="btn btn-danger" @click="deleteKeyValue(index)"><span class="btn-inner--icon"><i class="ni ni-fat-remove" style="font-size:15px" /></span></base-button>
                    <base-input placeholder="Key" v-model="dataAsArray[index][0]" @change="keyValueChanged(index,dataAsArray[index][0],dataAsArray[index][1])" />
                    <base-input v-if="dataAsArray[index][2]=='Text'" placeholder="Value" :type="dataAsArray[index][2].toLowerCase()" v-model="dataAsArray[index][1]" @change="keyValueChanged(index,dataAsArray[index][0],dataAsArray[index][1])" />
                    <base-input v-else-if="dataAsArray[index][2]=='Number'" placeholder="Value" :type="dataAsArray[index][2].toLowerCase()" v-model.number="dataAsArray[index][1]" @change="keyValueChanged(index,dataAsArray[index][0],dataAsArray[index][1])" />
                    <base-checkbox v-else v-model="dataAsArray[index][1]" />

                    <b-dropdown :text="dataAsArray[index][2]" variant="outline-light" >
                        <b-dropdown-item @click="changeDataType(index,'Text')">Text</b-dropdown-item>
                        <b-dropdown-item @click="changeDataType(index,'Number')">Number</b-dropdown-item>
                        <b-dropdown-item @click="changeDataType(index,'Checkbox')">Boolean</b-dropdown-item>
                    </b-dropdown>
            </div>
            <b-row>
                <b-col>
                    <base-button icon type="info" @click="addKeyValuePair()"><span class="btn-inner--icon"><i class="ni ni-fat-add" style="font-size:15px" /></span></base-button>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
    <!-- TODO: Aynı keye sahip değerler için kontrol -->
</template>

<script>
export default {
    name:'json-editor',
    props:{
        data:Object,
        paramKey:String,
    },
    data(){
        return {
            dataAsArray:[],
        }
    },
    created(){
        if(this.data===null || this.data===undefined){
            this.data={};
            return
        }
        this.convertFromFieldRelations()
    },
    methods:{
        convertFromFieldRelations(){
            this.dataAsArray=[];
            for(var key in this.data){
                var value=this.data[key];
                var value_type=typeof value;

                if(value_type=='number')
                    value_type='Number';
                else if(value_type=='boolean')
                    value_type='Checkbox';
                else
                    value_type='Text';

                this.dataAsArray.push([key,value,value_type]);
            }
        },
        convertToFieldRelations(){
            this.data={};
            for(var key in this.dataAsArray){
                var data_key=this.dataAsArray[key][0];
                var data_value=this.dataAsArray[key][1];
                var data_value_type=this.dataAsArray[key][2];

                if(data_value===NaN || data_value===undefined){
                    data_value=null;
                }
                else if(data_value_type=='Text'){
                    data_value=String(data_value);
                }
                else if(data_value_type=='Number'){
                    if(!isNaN(data_value)){
                        data_value=Number(data_value);
                    }
                    else{
                        data_value=''
                    }
                }
                else if(data_value_type=='Checkbox'){
                    data_value=(!!data_value);
                }

                this.dataAsArray[key][1]=data_value;
                this.data[data_key]=data_value;
            }
        },
        addKeyValuePair(){
            this.dataAsArray.push(['','','Text'])
        },
        keyValueChanged(index,key,value){
            this.dataAsArray[index][0] = key;
            this.dataAsArray[index][1] = value;
            
            this.updateKeyValuePairs();
        },
        changeDataType(index,type){
            this.dataAsArray[index][2]=type;
            this.updateKeyValuePairs();
            this.$forceUpdate();
        },
        deleteKeyValue(index){
            this.dataAsArray.splice(index,1);

            this.updateKeyValuePairs();
        },
        updateKeyValuePairs(){
            this.convertToFieldRelations();
            this.$emit('change',[this.data,this.paramKey]);
        }
    }
}
</script>

<style>

.je-input-row {
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top:5px;
}

.je-input-row button {
    max-height: 43px;
}

.je-input-row input {
    min-width: 150px;
}

</style>